var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(-0.079 -0.078)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 4,
    height: 4,
    rx: 1,
    transform: "translate(0.079 0.078)",
    fill: "#b6bdc3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 4,
    height: 4,
    rx: 1,
    transform: "translate(7.079 0.078)",
    fill: "#b6bdc3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 4,
    height: 4,
    rx: 1,
    transform: "translate(14.079 0.078)",
    fill: "#b6bdc3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 4,
    height: 4,
    rx: 1,
    transform: "translate(14.079 7.078)",
    fill: "#b6bdc3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 4,
    height: 4,
    rx: 1,
    transform: "translate(7.079 7.078)",
    fill: "#b6bdc3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 4,
    height: 4,
    rx: 1,
    transform: "translate(0.079 7.078)",
    fill: "#b6bdc3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 4,
    height: 4,
    rx: 1,
    transform: "translate(14.079 14.078)",
    fill: "#b6bdc3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 4,
    height: 4,
    rx: 1,
    transform: "translate(7.079 14.078)",
    fill: "#b6bdc3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 4,
    height: 4,
    rx: 1,
    transform: "translate(0.079 14.078)",
    fill: "#b6bdc3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/a.1fbe1645d7f4c902474e9cb5736736c6.svg";
export { ForwardRef as ReactComponent };